import axios from '../../../../utils/AxiosUtils';
import {
    GET_GIFTCARD_PROVIDERS,
    GET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS,
    LOADING,
    RESET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS
} from "../../../types";
import MessageUtils from '../../../../utils/MessageUtils';
import i18n from "../../../../i18next";


export const getGiftCardProviders = () => {
    return dispatch => {
        dispatch({ type:LOADING, payload: true });

        const url = `/gift-card-provider/`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type:GET_GIFTCARD_PROVIDERS, payload: response.data });
            })
            .catch(error => {
                dispatch({ type:LOADING, payload: false});
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions.posSettings.commonFailure'));
            })
    }
};

export const getRestaurantGiftCardProviderSettings = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/gift-card-provider/${restaurantId}/settings`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: GET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS, payload: response.data})
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const saveRestaurantGiftCardProviderSettings = (restaurantId, data, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/gift-card-provider/${restaurantId}/settings`;

        axios().put(url, data)
            .then(response => {
                dispatch({ type: LOADING, payload: false });

                if(callback) {
                    callback();
                }
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const resetRestaurantGiftCardProviderSettings = (restaurantId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true});

        const url = `/gift-card-provider/${restaurantId}/reset`;

        axios().put(url, {})
            .then(() => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: RESET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS, payload: false});

                if(callback) {
                    callback()
                }
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false});
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const invalidGiftCardProviderFormMessage = () => dispatch => {
    MessageUtils.errorMessageResponse(dispatch, '', i18n.t('screens:giftCardProviderScreen.emptyFields'));
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/GiftCardProviderActions.js